const dashboard = "/dashboard";
const todos = "/dashboard/todo";
const regularReports = "/dashboard/todo/regularreports";
const setupData = "/dashboard/todo/setupdata";

const yourSummary = "/dashboard/summary";

export {
	dashboard,
	todos,
	regularReports,
	setupData,
	yourSummary
};
